import "./App.css";
import NavBar from "./components/navbar/navbar";
import ProfessionalExperience from "./components/professional-experience/professional-experience";

function App() {
	return (
		<div className="App">
			<NavBar />
			<main>
				<ProfessionalExperience />
			</main>
		</div>
	);
}

export default App;
